import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { SaleItemRoutingModule } from './sale-item-routing.module'
import { SaleItemEffects } from './sale-item.effects'
import * as fromSaleItem from './sale-item.reducer'
import { SaleIteSerializer } from './sale-item.serializer'
import { SaleItemService } from './sale-item.service'
import { SaleItemTableComponent } from './table/table.component'
import { SaleItemCreateModalComponent } from './create-modal/show.component'
import { ProductModule } from '../../product/product.module'
import { ParticipationModule } from '../../booking/participation/participation.module'
import { BookableSlotModule } from '../../bookable-slot/bookable-slot.module'
import { SaleItemShowModalComponent } from './show-modal/show.component'
import { SaleItemFormComponent } from './form/form.component'
import { SaleItemPurchaseParamsFormComponent } from './form-purchase-params/form.component'
import { SaleItemsGroupByProductPipe } from './table/sale-item-group-by-product.pipe'
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm'
import { SaleItemParticipantsFormComponent } from './participants-form/participants-form.component'
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker'
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker'
import { GetSaleItemProductPricePipe } from './get-sale-item-product-price.pipe'
import { SaleItemFormCreateComponent } from './form-create/form.component'
import { BookingMultiDayModule } from '../booking-multi-day/booking-multi-day.module'
import { SaleBookingLinkItemMapPipe } from './form/sale-booking-link-item-map.pipe'
import { SaleItemAdjustParticipationsByTypeComponent } from './sale-item-adjust-participations-by-type/sale-item-adjust-participations-by-type.component'
import { SubsSaleItemFormCreateComponent } from './subs-form-create/form.component'
import { SubscriptionListComponent } from './subscription-list/subscription-list.component'
import * as fromSaleItemSurveyDraft from '../sale-item-survey-draft/sale-item-survey-draft.reducer'
import { SaleItemSurveyDraftEffects } from '../sale-item-survey-draft/sale-item-survey-draft.effects'
import { SaleItemCreateSurveyComponent } from './sale-item-create-survey/sale-item-create-survey.component'
import { RentalSaleItemFormCreateComponent } from './rental-form-create/form.component'

@NgModule({
  imports: [
    CommonModule,
    SaleItemRoutingModule,
    SharedModule,
    StoreModule.forFeature(
      fromSaleItem.FEATURE_NAME,
      fromSaleItem.saleItemReducer
    ),
    StoreModule.forFeature(
      fromSaleItemSurveyDraft.FEATURE_NAME,
      fromSaleItemSurveyDraft.saleItemSurveyDraftReducer
    ),
    EffectsModule.forFeature([SaleItemEffects, SaleItemSurveyDraftEffects]),
    ProductModule,
    ParticipationModule,
    BookableSlotModule,
    NzPopconfirmModule,
    NzDatePickerModule,
    NzTimePickerModule,
    BookingMultiDayModule
  ],
  declarations: [
    SaleItemTableComponent,
    SaleItemFormComponent,
    SaleItemFormCreateComponent,
    SubsSaleItemFormCreateComponent,
    RentalSaleItemFormCreateComponent,
    SubscriptionListComponent,
    SaleItemCreateModalComponent,
    SaleItemPurchaseParamsFormComponent,
    SaleItemShowModalComponent,
    SaleItemCreateSurveyComponent,
    SaleItemParticipantsFormComponent,
    SaleItemAdjustParticipationsByTypeComponent,
    SaleItemsGroupByProductPipe,
    GetSaleItemProductPricePipe,
    SaleBookingLinkItemMapPipe
  ],
  exports: [
    SaleItemTableComponent,
    SaleItemCreateModalComponent,
    SaleItemPurchaseParamsFormComponent,
    SaleItemCreateSurveyComponent,
    SaleItemAdjustParticipationsByTypeComponent
  ],
  providers: [
    SaleItemService,
    {
      provide: SaleIteSerializer,
      useClass: SaleIteSerializer
    }
  ]
})
export class SaleItemModule {}
